import { BCMSDefaultModel, BCMSRecord, Workflow, useGlobalController } from "@bcm-dev/bcms-vite";
import UserActivityPage from "components/pages/UserActivityPage";
import { UserActivity } from "model";
import React from "react";

// Steps of the workflow
const steps = [ <UserActivityPage /> ];

/**
 * @function UserActivityWorkflow
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @exported true
 * @description The workflow component for the "User Activity" page.
 * 
 * Setting constructor example for state captures:
 * 
 * document.dispatchEvent(new CustomEvent("force-workflow-state", {
  detail: { 
    value: { 
      userActivities: [
        { id: "1", date: "10", time: "10:00 AM", category: "1" },
        { id: "0", date: "-10", time: "9:00 AM", category: "0" },
      ]
    } 
  } 
}));
 */
export default function UserActivityWorkflow(props) {
    const controller = useGlobalController();
    // Get the inital state of the workflow
    const value = getDefault(controller);
    // Define the constructor function for forcing state through the 'force-workflow-state' event
    const constructor = record => {
        const userActivitiesObj = record.userActivities ?? [];
        const userActivities = userActivitiesObj.reduce((acc, activity) => {
            let userActivityInstance = UserActivity.initByID(activity.id);
            userActivityInstance = userActivityInstance === undefined ? 
            BCMSDefaultModel.userActivity()
            : UserActivity.initByID(activity.id);

            const mergedObj = { ...userActivityInstance.record, ...activity };
            const mergedUserActivity = UserActivity.init(mergedObj);
            acc.push(mergedUserActivity);
            return acc;
        }, []);
        const userActivitiesProp = userActivities.length > 0 ? { userActivities: userActivities } : {};

        // Return the new workflow default object.
        return { 
            ...getDefault(controller),
            ...userActivitiesProp
        };
    };

    // Return the workflow component
    return <Workflow value={ value } steps={ steps } constructor={ constructor } />
}
// Return the steps of the workflow
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {Controller} controller - A global controller.
 * @returns {Object}
 * @exported true
 * @description Function to get the default state of the workflow
 */
export const getDefault = controller => {
    BCMSRecord.globalControllerFor([ UserActivity ], controller);
    // Initalize mobile devices and accounts for the user.
    const userActivities = UserActivity.initAll();
    
    // Return the default workflow state
    return { 
        userActivities
    };
};